// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {
  FETCH_DEVICES
} from '../actions/deviceManagement'

const initialState = {
  devices: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DEVICES:
      return {...state, devices: action.payload.data}
    default:
      return state
  }
}
